// Puppocino Rescue theme: small progressive enhancements. Everything works without JavaScript.
(function () {
  // Close any open header dropdown when another opens or when clicking outside.
  var dropdowns = document.querySelectorAll('[data-nav-dropdown]');
  dropdowns.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      dropdowns.forEach(function (other) { if (other !== d) other.open = false; });
    });
  });
  document.addEventListener('click', function (e) {
    dropdowns.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    dropdowns.forEach(function (d) {
      if (d.open) { d.open = false; var s = d.querySelector('summary'); if (s) s.focus(); }
    });
  });

  // Product page: keep price and button in step with the chosen variant.
  var form = document.querySelector('[data-product-form]');
  var dataEl = document.querySelector('[data-product-variants]');
  if (form && dataEl) {
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    var select = form.querySelector('select[name="id"]');
    var price = document.querySelector('[data-product-price]');
    var button = form.querySelector('[data-add-button]');
    if (select) {
      select.addEventListener('change', function () {
        var v = variants.find(function (x) { return String(x.id) === select.value; });
        if (!v) return;
        if (price) price.textContent = v.price_formatted;
        if (button) {
          button.disabled = !v.available;
          button.textContent = v.available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }
  }
})();
